import { useGetOrdenesCompra } from "@/shared/actions/erp"
//import { LoaderComponent } from "@/shared/components/ui"
import { useParams } from "react-router-dom"
import { SaveOrdenesCompra } from "../../shared/saveOrdenesCompra"
import { PermissionsEnum } from "@/auth/interfaces"
import { useCheckPermissions } from "@/shared"

export default function EditarordenCompra() {

  useCheckPermissions(PermissionsEnum.api_change_ordencompra)
  const { id } = useParams()
  const { data: dataOrdenCompra, /* isLoading, isRefetching */ } = useGetOrdenesCompra(id!)

  //if (isLoading || isRefetching) return <LoaderComponent />
  return (
    <SaveOrdenesCompra titlePage="Editar Orden  de Pedido" editOrdenesCompra={dataOrdenCompra?.data} />
  )
}